import React, { Fragment, useState, useCallback } from 'react'
import { Box, Typography, IconButton } from '@mui/material'
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward'
import { useStyles } from './style'
import { putAwayActions } from '../../actions/putAwayActions'
import { usePutAway } from '../../Context/usePutAway'
import StepBackPutAway from '../StepBackPutAway/StepBackPutAway'
import FlipButtonFront from '../LocateHistoryPutAway/FlipButtonFront'
import { FlipButtonProductProblems } from '../LocateHistoryPutAway/FlipButtonProductProblems'
import { eTypePosition } from '../../types/enums'

/**
 Copyright 2023-09-11 por Alfonso Moya Ecomsur Holding S.A ©
 Detalle: Se modifica texto de sobrantes en ubicación de mercadería
 */

export const HeaderPutAway = () => {
  const classes = useStyles()

  const [showNoPositionsMessage, setShowNoPositionsMessage] = useState(false)


  const { expandCollapseHeaderAndGrid, recalculateItems, existsExcessOnVIew, checkPositionByType, setIsPreSale } =
    putAwayActions()
  const { state, dispatch } = usePutAway()
  const { item, calculatedInbound, SkuListOnPosition } = state

  React.useLayoutEffect(() => {
    recalculateItems()
  }, [SkuListOnPosition])

  // Valida posiciones de venta en verde solo para Asn para recepción venta en verde
  const handleCheckPositions = useCallback(async () => {
    setShowNoPositionsMessage(false) 

    try {
      // Validamos si existen posiciones de tipo venta en verde
      const hasPositions = await checkPositionByType(eTypePosition.VTAVRD)
      setShowNoPositionsMessage(!hasPositions)
    } catch (error) {
      console.error('Error verificando posiciones:', error)
      setShowNoPositionsMessage(true) 
    }
  }, [checkPositionByType])

  // Para ASN de tipo venta en verde se valida si existe al menos una posición
  React.useEffect(() => {
    if (item?.isPreSaleReception) {
      handleCheckPositions()
      dispatch(setIsPreSale(true))
    }
  }, [item?.isPreSaleReception, handleCheckPositions]) 


  return (
    <Fragment>
      <StepBackPutAway />

      <Box
        component='div'
        display='flex'
        flexDirection='row'
        flexWrap='nowrap'
        alignItems='center'
        width='100%'
        borderRadius='5px'
        style={{ backgroundColor: '#e0e0e0' }}
      >
        <div
          id='containerHeaderPutAway'
          className={classes['#containerHeaderPutAway']}
          style={{
            height: (item?.isPreSaleReception && state.isExcess) || (item?.isPreSaleReception && showNoPositionsMessage) ? '170px' : '140px'
          }}
        >
          <div
            className='wrapperHeader'
            style={{ 
              height: item?.isPreSaleReception && state.isExcess ? '170px' : '140px',
              paddingLeft: '15px' }}
          >
            <div className='descripcion' style={{ textIndent: '13%' }}>
              {item?.isPreSaleReception && (
                <Typography variant='h6' style={{ color: 'rgb(0, 75, 177)' }}>
                  {' '}
                  {`Recepción para venta en verde.`}
                </Typography>
              )}
              {showNoPositionsMessage && (
                <Typography variant='body1' style={{ color: 'red' }}>
                  {' '}
                  {`Sin posiciones de tipo venta en verde creadas.`}
                </Typography>
              )}
              <Typography variant='h6' className={classes.details}>
                <b>ASN: </b>
                {item?.asnNumber}
              </Typography>
              {item?.workingLpn && (
                <Typography variant='h6' className={classes.details}>
                  <b>LPN: </b> {item?.workingLpn}
                </Typography>
              )}
              <Typography variant='h6' className={classes.details}>
                <b>OT: </b>
                {item?.workOrderId}
              </Typography>
              <Typography variant='h6' className={classes.details}>
                <b>Marca: </b>
                {item?.brandName}
              </Typography>
              {existsExcessOnVIew() && (
                <Typography variant='h6' style={{ color: 'red' }}>
                  {' '}
                  {`Se han ingresado sobrantes.`}
                </Typography>
              )}
              <div
                id='containerDetails'
                className={classes['#containerDetails']}
              >
                <Typography variant='h6' className={classes.details}>
                  <b>Total unidades: </b>
                  {item?.unitsQty!}
                </Typography>
                <Typography variant='h6' className={classes.details}>
                  <b>Unidades ingresadas: </b>
                  {calculatedInbound}
                </Typography>
                <Typography variant='h6' className={classes.details}>
                  <b>Unidades por ingresar: </b>
                  {item?.unitsQty! - calculatedInbound < 0
                    ? 0
                    : item?.unitsQty! - calculatedInbound}
                </Typography>
              </div>
            </div>
          </div>
        </div>
        <Box
          textAlign={'right'}
          display={'flex'}
          flexDirection={'column'}
          justifyContent={'flex-start'}
        >
          <FlipButtonFront />
          <FlipButtonProductProblems />
        </Box>
      </Box>
      <Box
        component='div'
        display='flex'
        flexDirection='row'
        flexWrap='nowrap'
        alignItems='center'
        width='100%'
        justifyContent='center'
      >
        <IconButton
          style={{
            position: 'absolute',
            borderRadius: '50%',
            background: 'white',
            height: '21px',
            width: '21px',
            minWidth: '21px',
            minHeight: '21px',
            border: '2px solid #B6B5B5',
            zIndex: 1
          }}
          type='button'
          onClick={() => expandCollapseHeaderAndGrid()}
          id='more-button'
        >
          <ArrowDownwardIcon />
        </IconButton>
      </Box>
    </Fragment>
  )
}
